var map = {
	"./1.png": "0ca1",
	"./Prikaz_Ministra1.jpg": "d2fa",
	"./Prikaz_Ministra2.jpg": "3894",
	"./icons/010.png": "22c0",
	"./icons/012.png": "4b6d",
	"./icons/015.png": "15e8",
	"./icons/13.png": "4914",
	"./icons/15.png": "7f1b",
	"./icons/15_blue.png": "c915",
	"./icons/18.png": "a4a3",
	"./icons/2.png": "e493",
	"./icons/20.png": "30d8",
	"./icons/23.png": "889e",
	"./icons/25.png": "cd25",
	"./icons/28.png": "5016",
	"./icons/34.png": "71aa",
	"./icons/38.png": "a874",
	"./icons/4.png": "bbd9",
	"./icons/40.webp": "2476",
	"./icons/4_.png": "b26d",
	"./icons/5.png": "a789",
	"./icons/6.png": "ace6",
	"./icons/attention.png": "ea41",
	"./icons/bubblequestion.webp": "3a49",
	"./icons/download.png": "fa8b",
	"./icons/dpo.png": "6a5b",
	"./icons/libre.png": "1022",
	"./icons/lk.png": "2f72",
	"./icons/lms.png": "288d",
	"./icons/manual.png": "3bc0",
	"./icons/mook.png": "8bf1",
	"./icons/order.png": "9681",
	"./icons/out.png": "dfe9",
	"./icons/raspzan.png": "33ba",
	"./icons/report.png": "7553",
	"./icons/shlyapa.png": "4a03",
	"./icons/sup.png": "96b6",
	"./icons/teacher.png": "d50e",
	"./icons/voskl.png": "6d18",
	"./logo.ico": "2c92",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo4---.ico": "3eab",
	"./logoSmall.png": "30c6",
	"./logo_old.png": "df01",
	"./minest.webp": "5e70",
	"./peopleincircle.png": "b1ed",
	"./unilogo.png": "dad7",
	"./фон_большой.jpg": "e7f7",
	"./фон_мобильный-в.jpg": "0f39",
	"./фон_мобильный-г.jpg": "240d",
	"./фон_п_в.jpg": "0db6",
	"./фон_планшет.jpg": "e246"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";